import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { PackageExportErrorMessage } from './package-export-error.message';


@PresenterType(
{
    model: PackageExportErrorMessage
})
@Component({
  selector: 'package-export-error-message',
  standalone: false,
  templateUrl: './package-export-error-message.component.html',
  styleUrl: './package-export-error-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageExportErrorMessageComponent {
    public data: WritableSignal<PackageExportErrorMessage>;
    
    constructor() {
        this.data = signal<PackageExportErrorMessage>(null);
    }
}
